import EventBus from '@/eventBus'

const MESSAGE_TYPES = {
  AUDIENCE_LEAVE_TEAM: 'aLQT',
  QUIZ_SHOW_ANSWER: 'quiz-show-answer',
}

function handleShowQuizAnswer(doc, editor) {
  if (!editor.sharePresentation) {
    return
  }

  if (editor.slideActive.id === parseInt(doc.data.slideId, 10)) {
    EventBus.$emit('eventShowQuizTypeAnswer')
  }
}

function _handleChangeQuizTeam(editor, data) {
  if (editor.$store.state.audiences[data.a]) {
    delete editor.$store.state.audiences[data.a]
  }
}

function handleAudienceChangeTeam(doc, editor) {
  _handleChangeQuizTeam(editor, doc.data)
  EventBus.$emit('gamelobby-leave-team', doc.data)
  editor._setTeamData()
}

const QuizWebsocketSubscriber = {
  [MESSAGE_TYPES.QUIZ_SHOW_ANSWER]: handleShowQuizAnswer,
  [MESSAGE_TYPES.AUDIENCE_LEAVE_TEAM]: handleAudienceChangeTeam,
}

export default QuizWebsocketSubscriber
